import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-item" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { class: "ml-1" }

import { ref, computed, onMounted, watch, PropType, inject } from "vue";
import { EmployeeModel } from "../models";
import { TirPmIconView } from "tir-components";
import { QueueTasksModel } from "@/components/sidebar/models";

// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'user-item',
  props: {
  user: { type: EmployeeModel, value: true },
  /**Редактируемая очередь */
  queue: { type: Object as PropType<QueueTasksModel> },
},
  setup(__props) {

const props = __props;

// Импорты из Vue 3 Composition API



// // Определение эмиттеров событий компонента
// const emits = defineEmits<{
//   clickLogout: [], // Событие при клике на кнопку "Выход"
//   "update:message": [string]; // Событие обновления сообщения
// }>();

// // Отслеживание изменений пропса isCompact
// watch(
//   () => props.isCompact,
//   () => {
//     if (props.isCompact) {
//       console.log("Свойство isCompact поменялось на true");
//     }
//   }
// );

// const latitude = computed({
// get() {
// return lat.value || props.Latitude || 0;
// },
// set(newValue: number) {
// console.log(`newValue`, newValue);
// lat.value = newValue;
// },
// });
// // Блок переменных
// const count = ref(0); // Переменная для подсчета
// const message = ref(""); // Переменная для сообщения

// // Жизненный цикл компонента (при монтировании)
// onMounted(() => {
//   console.log("Компонент монтирован.");
// });

// // Вычисляемое свойство (двойное значение счетчика)
// const doubledCount = computed(() => count.value * 2);

// // Функция для увеличения счетчика
// function increment() {
//   count.value++;
// }

// // Функция для изменения сообщения и эмиттинга события обновления
// function changeMessage() {
//   message.value = "Новое сообщение!";
//   emits("update:message", message.value);
// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmIconView), {
        isRounded: "",
        size: 24,
        colorCode: __props.user.AvatarColor,
        "image-load-url": __props.user.Foto
      }, {
        mainSlot: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.user.Initials), 1)
        ]),
        _: 1
      }, 8, ["colorCode", "image-load-url"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.user.Name), 1)
    ])
  ]))
}
}

})